import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "upload-frame" }
const _hoisted_2 = { class: "text-center text-uppercase mb-1 text-primary fw-bolder fs-3" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = {
  key: 0,
  class: "uplaod-list-style my-10"
}
const _hoisted_5 = {
  key: 1,
  class: "text-center text-primary"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 0,
  class: "d-flex align-items-center justify-content-center"
}
const _hoisted_8 = ["id", "name"]
const _hoisted_9 = ["for"]
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-lg btn-danger" }, "Remove Image", -1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WebCamSelfie = _resolveComponent("WebCamSelfie")!
  const _component_WebCamDocument = _resolveComponent("WebCamDocument")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.subtitle), 1),
    (!_ctx.isCameraOpen)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.uploading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Uploading image... "))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (!_ctx.official_doc && !_ctx.capturedDoc && !_ctx.isCameraOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: _normalizeClass(["btn btn-lg btn-primary", _ctx.mode !== 'selfie' ? 'd-block d-md-none' : '']),
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCamera && _ctx.openCamera(...args)))
                }, " Take Picture ", 2),
                (_ctx.mode === 'upload')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("input", {
                        id: _ctx.name,
                        name: _ctx.name,
                        class: "visually-hidden",
                        type: "file",
                        accept: ".png, .jpg, .jpeg",
                        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.uploadImage && _ctx.uploadImage(...args)))
                      }, null, 40, _hoisted_8),
                      _createElementVNode("label", {
                        class: "btn btn-lg btn-light-primary ms-5",
                        for: _ctx.name
                      }, " Upload Picture ", 8, _hoisted_9)
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.mode === 'selfie')
            ? (_openBlock(), _createBlock(_component_WebCamSelfie, {
                key: 1,
                ref: "webCam",
                "ensure-face-detection": "",
                onPhotoTaken: _ctx.livephotoSelfie,
                "onClose:camera": _ctx.closeCamera
              }, null, 8, ["onPhotoTaken", "onClose:camera"]))
            : (_openBlock(), _createBlock(_component_WebCamDocument, {
                key: 2,
                ref: "webCam",
                onPhotoTaken: _ctx.livephoto,
                "onClose:camera": _ctx.closeCamera
              }, null, 8, ["onPhotoTaken", "onClose:camera"])),
          (_ctx.official_doc || _ctx.capturedDoc)
            ? (_openBlock(), _createElementBlock("img", {
                key: 3,
                src: _ctx.official_doc || _ctx.capturedDoc,
                class: "img-fluid-kyc my-5 mx-auto d-block",
                alt: _ctx.name
              }, null, 8, _hoisted_10))
            : _createCommentVNode("", true),
          (_ctx.official_doc)
            ? (_openBlock(), _createElementBlock("div", {
                key: 4,
                class: "d-flex align-items-center justify-content-center",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeFile && _ctx.removeFile(...args)))
              }, _hoisted_12))
            : _createCommentVNode("", true)
        ]))
  ]))
}